import { protectedPost, protectedUpload } from "@/lib/api";

export function fmtBytes(n) {
  if (!n && n !== 0) return "—";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / 1024 / 1024).toFixed(1)} MB`;
  return `${(n / 1024 / 1024 / 1024).toFixed(2)} GB`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString([], { month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" });
}

// Chunked upload: init → N chunks → complete. Bypasses proxy body limits and reports progress.
export async function uploadChunked(file, { workspace = "global", onProgress } = {}) {
  const init = await protectedPost("/files/upload/init", {
    name: file.name, size: file.size, content_type: file.type || "application/octet-stream", workspace,
  });
  const { upload_id, chunk_size } = init;
  let offset = 0;
  let index = 0;
  while (offset < file.size) {
    const blob = file.slice(offset, offset + chunk_size);
    const fd = new FormData();
    fd.append("index", String(index));
    fd.append("chunk", blob, "chunk");
    await protectedUpload(`/files/upload/${upload_id}/chunk`, fd);
    offset += blob.size;
    index += 1;
    onProgress?.(Math.min(99, Math.round((offset / file.size) * 100)));
  }
  const rec = await protectedPost(`/files/upload/${upload_id}/complete`);
  onProgress?.(100);
  return rec;
}
